// Client-side mirror of functions/strategyCredits/propertyKey.js, for
// display/lookup only (which strategyProperties doc to read, "Current vs
// Previous Property" grouping). NOT authoritative - every security-relevant
// check (unlock, entitlement, generation) always recomputes this same key
// server-side from the transaction's own address, never trusting a
// client-supplied value.

const ADDRESS_WORD_NORMALIZATION = {
  street: "st", road: "rd", avenue: "ave", boulevard: "blvd", drive: "dr",
  lane: "ln", court: "ct", place: "pl", circle: "cir", terrace: "ter",
  parkway: "pkwy", highway: "hwy", trail: "trl", apartment: "apt", suite: "ste",
  north: "n", south: "s", east: "e", west: "w",
  northeast: "ne", northwest: "nw", southeast: "se", southwest: "sw",
};

function normalizeAddressToken(word) {
  const clean = word.toLowerCase().replace(/[.,#]/g, "");
  return ADDRESS_WORD_NORMALIZATION[clean] || clean;
}

function normalizeTokens(value) {
  return (value || "")
    .split(/\s+/)
    .filter(Boolean)
    .map(normalizeAddressToken)
    .join("-");
}

export function buildPropertyKey(address) {
  if (!address) return null;
  const streetPart = normalizeTokens(address.street);
  const unitPart = normalizeTokens(address.unit);
  const cityPart = (address.city || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-+|-+$)/g, "");
  const statePart = (address.state || "").toLowerCase().replace(/[^a-z]/g, "");
  const zipPart = (address.zipcode || "").replace(/[^0-9]/g, "").slice(0, 5);

  if (!streetPart || !cityPart || !statePart) return null;

  return [streetPart, unitPart, cityPart, statePart, zipPart].filter(Boolean).join("_");
}
